<template>
  <div class="tasks-categorical">
    <b-loading :active="isLoading"></b-loading>
    <div class="columns">
      <div class="column is-full">
        <b-tabs type="is-boxed">
          <b-tab-item :label="$t('categories-view.categories')">
            <div class="columns is-vcentered" style="margin-top: 16px">
              <div class="column">
                <b-button class="button is-primary is-mobile" icon-left="plus-thick"
                          @click="addNewTaskCategoryClicked">
                  {{ $t('common.add') }}
                </b-button>
              </div>
            </div>
            <div class="columns">
              <div class="column is-full">
                <b-table class="templates-table" :data="categories" :striped="true" :hoverable="true"
                         :mobile-cards="true" :scrollable="true">
                  <b-table-column field="" :label="this.$t('categories-view.name')"
                                  v-slot="props">
                    {{ props.row }}
                  </b-table-column>
                  <b-table-column v-slot="props" cellClass="has-text-right">
                    <b-button class="button is-primary is-danger is-small" icon-left="delete" style="margin-left: 8px"
                              @click="deleteCategoryClicked(props.row)">
                      {{ $t('categories-view.delete') }}
                    </b-button>
                  </b-table-column>
                </b-table>
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "TasksCategorical",
  props: {
    categorical_data: {
      category: []
    }
  },
  data() {
    return {
      categories: [],
      isLoading: false
    }
  },
  watch: {
    categorical_data: function () {
      this.categories = this.categorical_data.category
    }
  },
  methods: {
    /*
     UI Events
     */
    deleteCategoryClicked: function (category) {
      const confirmBlock = () => {
        const categoriesToUpdate = JSON.parse(JSON.stringify(this.categories));
        for (let i = categoriesToUpdate.length - 1; i >= 0; i--) {
          if (categoriesToUpdate[i] === category) categoriesToUpdate.splice(i, 1);
        }
        const payload = {
          data: categoriesToUpdate,
          collectionName: "tasks",
          dataFieldTitle: "category"
        }
        this.$emit('updateCategoricalData', payload)
      }
      this.$emit('deleteCategoricalData', confirmBlock)
    },
    addNewTaskCategoryClicked: function () {
      const confirmBlock = (value) => {
        if (value !== '' && !this.categories.includes(value)) {
          const categoriesToUpdate = JSON.parse(JSON.stringify(this.categories));
          categoriesToUpdate.push(value)
          const payload = {
            data: categoriesToUpdate,
            collectionName: "tasks",
            dataFieldTitle: "category"
          }
          this.$emit('updateCategoricalData', payload)
        } else {
          this.showError(this.$t("categories-view.generic-add-element-error"))
        }
      }
      this.$emit('addCategoricalData', confirmBlock)
    }
  },
  mounted() {
  }
};
</script>

<style scoped>
.tasks-categorical {
  margin-top: 16px;
}
</style>
